export default [{
  path: "/game/my",
  name: "MyGame",
  meta: {
    title: "我的游戏",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/game/my/index.vue")
}, {
  path: "/game/apply",
  name: "ApplyGame",
  meta: {
    title: "申请游戏",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/game/apply/index.vue")
}, {
  path: "/game/start",
  name: "StartGame",
  meta: {
    title: "开始游戏",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/game/start/index.vue")
}, {
  path: "/game/choose",
  name: "ChooseGame",
  meta: {
    title: "选择游戏",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/game/choose/index.vue")
}, {
  path: "/game/discus",
  name: "DiscusGame",
  meta: {
    title: "选择游戏",
    keepAlive: true,
    auth: true
  },
  component: () => import("@views/game/discus/index.vue")
}, ]